import { INotification } from '../../types/notifications';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ENotificationsActionTypes {
  PushNotification = 'notifications/PUSH_NOTIFICATION',
  RemoveNotification = 'notifications/REMOVE_NOTIFICATION',
}

export type TPushNotifications = ITypedReduxAction<ENotificationsActionTypes.PushNotification, INotification>;
export type TRemoveNotification = ITypedReduxAction<ENotificationsActionTypes.RemoveNotification, string>;

export const pushNotification = actionGenerator<ENotificationsActionTypes.PushNotification, INotification>(
  ENotificationsActionTypes.PushNotification,
);

export const removeNotification = actionGenerator<ENotificationsActionTypes.RemoveNotification, string>(
  ENotificationsActionTypes.RemoveNotification,
);

export type TNotificationActions = TPushNotifications | TRemoveNotification;
